import SiteConfigNiveauxController from './site.config.niveaux.controller';

export default {
    template: require('./site.config.niveaux.tpl.html'),
    controller: SiteConfigNiveauxController,
    bindings: {}
};
